import { Controller } from '@hotwired/stimulus';
import { scopeStyle } from 'manage/scope_style';

// 本文の <style> がそのまま描かれると管理画面の全体に効くので、<template> に入れて描かずにおき、作成画面のプレビューのモーダルと同じ先へ閉じ込めてから描く
export default class extends Controller {
  static targets = ['template'];

  connect() {
    const content = this.templateTarget.content.cloneNode(true);
    for (const style of content.querySelectorAll('style')) {
      style.textContent = scopeStyle(
        style.textContent,
        '.user_message_preview #content',
      );
    }
    this.templateTarget.replaceWith(content);
  }
}
